import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { getLatestComics } from '@/mocks/comics';

export default function LatestUpdate() {
  const latest = getLatestComics(6);

  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            <a href="#latest-update">最新更新</a>
          </h2>
          <p className="text-sm text-foreground-500 mt-1">刚刚更新的<strong>韩漫在线免费阅读</strong>内容</p>
        </div>
        <Link
          to="/category/all"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看全部
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-xs"></i>
          </div>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
        {latest.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}